// src/components/charts/CustomersGrowthChart.tsx
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend
} from 'recharts';
import { useEffect, useState } from 'react';
import axios from 'axios';

const CustomersGrowthChart = () => {
  const [data, setData] = useState([]);
  const API = process.env.REACT_APP_API_URL;

  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    };
  };

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const response = await axios.get(`${API}/analytics/customers-monthly`, getAuthHeader());
        setData(response.data);
      } catch (err) {
        console.error("Failed to load chart data", err);
      }
    };

    fetchChartData();
  }, []);

  return (
    <div className="bg-white rounded shadow p-4">
      <h2 className="text-base font-semibold mb-4">Pertumbuhan Pelanggan Baru (12 Bulan Terakhir)</h2>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id="colorTotal" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#00c0ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#00c0ff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" 
		    tick={{ fontSize: 13 }}
		  />
          <YAxis 
		    tick={{ fontSize: 13 }}
		  />
          <Tooltip />
          <Legend />
          <Area
            type="monotone"
            dataKey="total"
            stroke="#00c0ff"
            fillOpacity={1}
            fill="url(#colorTotal)"
            name="Pelanggan Baru"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomersGrowthChart;
